// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1__Fe","cls2":"BulkFollowSuggestion-cls2_RFP BulkFollowSuggestion-cls1__Fe","suggested":"BulkFollowSuggestion-suggested_eXz"};